var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveconversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FB47AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4843 13.8908V17.5575C20.4843 17.7958 20.4751 18.025 20.4476 18.245C20.2368 20.72 18.7793 21.9483 16.0934 21.9483H15.7268C15.4976 21.9483 15.2776 22.0583 15.1401 22.2417L14.0401 23.7083C13.5543 24.3592 12.7659 24.3592 12.2801 23.7083L11.1801 22.2417C11.0609 22.0858 10.7951 21.9483 10.5934 21.9483H10.2268C7.30261 21.9483 5.83594 21.2242 5.83594 17.5575V13.8908C5.83594 11.205 7.07345 9.74751 9.53928 9.53667C9.75928 9.50917 9.98845 9.5 10.2268 9.5H16.0934C19.0176 9.5 20.4843 10.9667 20.4843 13.8908Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1468 10.2229V13.8895C24.1468 16.5845 22.9093 18.0329 20.4435 18.2437C20.471 18.0237 20.4802 17.7945 20.4802 17.5562V13.8895C20.4802 10.9654 19.0135 9.4987 16.0893 9.4987H10.2227C9.98432 9.4987 9.75516 9.50787 9.53516 9.53537C9.74599 7.06954 11.2035 5.83203 13.8893 5.83203H19.756C22.6802 5.83203 24.1468 7.29871 24.1468 10.2229Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3722 16.1458H16.3804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1612 16.1458H13.1695",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95421 16.1458H9.96246",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveconversion);
export default __webpack_public_path__ + "static/media/liveconversion.4144b1295eed38080c05b7cc7325eb10.svg";
export { ForwardRef as ReactComponent };